import { PLACEHOLDER_OWL_IMAGE } from "helpers"
import { SERVER_BASE_URL } from "helpers/constants"

export default function useAvatar(path = "") {
	return path ? SERVER_BASE_URL + path : SERVER_BASE_URL + PLACEHOLDER_OWL_IMAGE
}
